module.exports = __webpack_public_path__ + "static/img/anticipo.7fcaad4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anticipo.png
// module id = +NDf
// module chunks = 1